import React, { useState } from "react";
import { Button } from "@material-ui/core";
import PreshiftPopup from "./PreshiftPopup";
import { PreshiftStyle } from "./style";

function Preshift(props) {
  const classes = PreshiftStyle();
  const [open, setOpen] = useState(false);
  const [preshiftQuestions, setPreshiftQuestions] = useState([]);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("displayOrder");
  const [isSavedChangeEnabled, setSavedChangeEnabled] = useState(false);
  const [detectedChanges, setDetectedChanges] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setPreshiftQuestions([]);
    setOrder("asc");
    setOrderBy("displayOrder");
    setSearch("");
    setSavedChangeEnabled(false);
    setDetectedChanges(true)
  };
  const handleClose = (isChanged) => {
    setOpen(isChanged);
    setDetectedChanges(true);
  };

  return (
    <div className={classes.PreshiftWrapper}>
      <Button
        className="orange-btn primary-btn"
        color="inherit"
        disableElevation
        underlinenone="true"
        onClick={handleClickOpen}
      >
        Preshift
      </Button>

      <PreshiftPopup
        handleClose={handleClose}
        open={open}
        setOpen={setOpen}
        preshiftQuestions={preshiftQuestions}
        setPreshiftQuestions={setPreshiftQuestions}
        search={search}
        setSearch={setSearch}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        isSavedChangeEnabled={isSavedChangeEnabled}
        setSavedChangeEnabled={setSavedChangeEnabled}
        detectedChanges={detectedChanges}
        setDetectedChanges={setDetectedChanges}
      />
    </div>
  );
}

export default Preshift;
